module.exports = __webpack_public_path__ + "img/a_top_search.a2ddf610.png";